var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG7LogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 32,
    viewBox: "0 0 142 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EF233C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 9L6.00517 9.00828L6 9L10.052 15.1898H15.3014L15.29 15.1733L15.3014 15.1898L14.1091 13.3677H17.893L13.3763 20.2694L16 24.277L26 9H6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2811 19.6467H53.9892C53.5689 20.0687 53.037 20.3937 52.3904 20.6217C51.6698 20.8762 50.843 21.0029 49.909 21.0029C48.975 21.0029 48.115 20.841 47.4073 20.5149C46.7006 20.1899 46.158 19.7029 45.7806 19.0518C45.4031 18.4018 45.2144 17.5965 45.2144 16.6347C45.2144 15.6729 45.3859 14.8818 45.7291 14.2605C46.0722 13.6391 46.5623 13.172 47.2014 12.8613C47.8394 12.5506 48.5976 12.3953 49.4769 12.3953C50.19 12.3953 50.8355 12.4834 51.4124 12.6608C51.9893 12.8382 52.473 13.0916 52.8644 13.4243C53.2558 13.757 53.512 14.1558 53.6364 14.6218H58.4533C58.2335 13.3923 57.7392 12.3038 56.9714 11.3564C56.2025 10.41 55.1902 9.66744 53.9345 9.13091C52.6788 8.59328 51.1787 8.32556 49.4361 8.32556C48.1729 8.32556 46.9966 8.50624 45.9049 8.8665C44.8133 9.22676 43.8525 9.75668 43.0225 10.4563C42.1915 11.1559 41.547 12.0218 41.087 13.053C40.6269 14.0853 40.3975 15.2796 40.3975 16.6358C40.3975 17.992 40.6269 19.1873 41.087 20.2185C41.547 21.2508 42.1818 22.1157 42.9914 22.8153C43.801 23.5148 44.734 24.0448 45.7913 24.4061C46.8475 24.7664 47.9799 24.9471 49.1884 24.9471C50.4784 24.9471 51.6033 24.7532 52.5652 24.3643C53.526 23.9754 54.3217 23.4388 54.9533 22.7525C54.9779 22.726 55.0015 22.6996 55.0251 22.672V24.946H58.597V16.2116H50.28V19.6467H50.2811Z",
    fill: "#EF233C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1413 8.68475L60.0886 24.946H65.2036L66.5194 21.7235H74.1093L75.4197 24.946H80.5572L73.482 8.68475H67.1413ZM68.13 17.7805L70.3208 12.4162L72.504 17.7805H68.13Z",
    fill: "#EF233C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6439 19.682L89.4383 8.68475H82.0467V24.946H86.5966V13.0123L91.2494 24.946H96.0256L100.658 12.9858V24.946H105.228V8.68475H97.8164L93.6439 19.682Z",
    fill: "#EF233C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.314 8.68475V24.946H121.952V21.0063V21.0019H112.408V18.5539H121.232V15.078V15.0769H112.408V12.6289H121.952V8.68475H107.314Z",
    fill: "#EF233C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.038 8.68475V12.544H133.743L125.91 24.946H131.455L139.006 12.6068L141.405 8.68475H124.038Z",
    fill: "#EF233C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG7LogoFull);
export default __webpack_public_path__ + "static/media/g7-logo-full.92ba46c196b95f5485caad64d2453394.svg";
export { ForwardRef as ReactComponent };